<div [formGroup]="formGroup">
  <nz-form-item>
    <nz-form-control [nzErrorTip]="phoneErrorTpl">
      <ngx-intl-tel-input
        [cssClass]="cssClass + ' ant-input'"
        [formControlName]="controlName"
        [inputId]="controlName"
        [preferredCountries]="preferredCountries"
        [onlyCountries]="onlyCountries"
        [enableAutoCountrySelect]="enableAutoCountrySelect"
        [enablePlaceholder]="enablePlaceholder"
        [customPlaceholder]="customPlaceholder"
        [numberFormat]="numberFormat"
        [searchCountryFlag]="searchCountryFlag"
        [searchCountryField]="searchCountryField"
        [searchCountryPlaceholder]="searchCountryPlaceholder"
        [maxLength]="maxLength"
        [selectFirstCountry]="selectFirstCountry"
        [phoneValidation]="phoneValidation"
        [selectedCountryISO]="selectedCountryISO"
        [separateDialCode]="separateDialCode"
        (ngModelChange)="onChangePhone($event)"
      ></ngx-intl-tel-input>
      <ng-template #phoneErrorTpl let-control>
        <ng-container
          *ngIf="
            control.hasError('required') && formGroup.get(controlName).dirty
          "
        >
          {{ "FORM.ERR.REQUIRED_PHONE_NUMBER" | translate }}
        </ng-container>
        <ng-container
          *ngIf="
            control.hasError('validatePhoneNumber') &&
            formGroup.get(controlName).dirty
          "
        >
          {{ "FORM.ERR.PHONE_NUMBER_INVALID" | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
</div>
